export default __webpack_public_path__ + "static/media/ActiveWaitlist.707c240b.svg";